import "./css/Button.css";
export default function Button({
  type,
  value,
  variant,
  iconBefore,
  iconAfter,
  className,
  sm,
  disabled,
  ...props
}) {
  const computedClassName = [
    "btn",
    (!!variant && `btn-${variant}`) || "",
    (!!sm && "btn-sm") || "",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  return (
    <button
      type={type}
      className={computedClassName}
      disabled={disabled}
      {...props}
    >
      {!!iconBefore && iconBefore}
      {value}
      {!!iconAfter && iconAfter}
    </button>
  );
}

Button.defaultProps = {
  type: "button",
  className: "",
};
